export default __webpack_public_path__ + "static/media/x-icon.2984797e2b504eb9a9ff87f9bf798e25.svg";